import type { z } from "zod";

import { zSchema } from "../../../../entity";

import { zWithLanguage } from "~/shared/zod";

const zIn = zSchema
  .pick({
    id: true,
  })
  .merge(zWithLanguage.partial());
type In = z.infer<typeof zIn>;

const zOut = zSchema;
type Out = z.infer<typeof zOut>;

export { zIn, zOut };
export type { In, Out };
